import { render, staticRenderFns } from "./NodeRing.vue?vue&type=template&id=10806dde&scoped=true"
import script from "./NodeRing.vue?vue&type=script&lang=js"
export * from "./NodeRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10806dde",
  null
  
)

export default component.exports